import React, { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const MoveCircle: FC<IconProps> = ({ width = 30, height = 30, fill = '#F7F7F7', className }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="30" height="30" rx="6" />
      <path
        d="M22.07 8.2A9 9 0 0 0 6.53 12.9C6.44 13.31 6.7 13.71 7.1 13.8C7.51 13.9 7.91 13.64 8 13.23A7.5 7.5 0 0 1 20.9 9.32L19.16 9.15C18.75 9.11 18.38 9.41 18.34 9.82C18.3 10.23 18.6 10.6 19.01 10.64L22.46 10.98C22.87 11.02 23.24 10.72 23.28 10.31L23.62 6.86C23.66 6.45 23.36 6.08 22.95 6.04C22.54 6 22.17 6.3 22.13 6.71L22.07 8.2Z"
        fill={fill}
      />
      <path
        d="M7.93 21.8A9 9 0 0 0 23.47 17.1C23.56 16.69 23.3 16.29 22.9 16.2C22.49 16.1 22.09 16.36 22 16.77A7.5 7.5 0 0 1 9.1 20.68L10.84 20.85C11.25 20.89 11.62 20.59 11.66 20.18C11.7 19.77 11.4 19.4 10.99 19.36L7.54 19.02C7.13 18.98 6.76 19.28 6.72 19.69L6.38 23.14C6.34 23.55 6.64 23.92 7.05 23.96C7.46 24 7.83 23.7 7.87 23.29L7.93 21.8Z"
        fill={fill}
      />
    </svg>
  );
};
